import React, { useState } from 'react';

const RejectReasonModal = ({ isOpen, onClose, onConfirm, userName }) => {
  const [reason, setReason] = useState('');

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (reason.trim()) {
      onConfirm(reason);
      setReason('');
      onClose();
    }
  };

  const handleCancel = () => {
    setReason('');
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div className="bg-jp-section rounded-2xl p-6 w-full max-w-md border border-jp-line">
        <h2 className="text-xl font-bold text-jp-ink mb-4">
          Reject User Registration
        </h2>

        <p className="text-sm text-jp-muted mb-4">
          You are about to reject the registration for <span className="font-semibold text-jp-ink">{userName}</span>.
          Please provide a reason for rejection.
        </p>

        <div className="mb-6">
          <label className="block text-sm font-medium text-jp-muted mb-2">
            Rejection Reason <span className="text-red-600 dark:text-red-400">*</span>
          </label>
          <textarea
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter the reason for rejection..."
            className="w-full px-4 py-3 bg-jp-field border border-jp-line rounded-lg text-jp-ink placeholder-jp-muted/70 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent resize-none"
            rows={4}
          />
        </div>

        <div className="flex gap-3 justify-end">
          <button
            onClick={handleCancel}
            className="px-5 py-2 rounded-lg border border-jp-line text-jp-muted hover:bg-jp-line transition-colors text-sm font-medium"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            disabled={!reason.trim()}
            className="px-5 py-2 rounded-lg bg-red-600 text-white hover:bg-red-500 transition-colors text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Confirm Rejection
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectReasonModal;
